import { SearchConditionLabelResponse } from '@doda/api-client/aspida/@types';
import { ArrowRight, DescriptionList } from '@doda/io-react/common';
import { FC } from 'react';
import styles from './index.module.scss';

/**
 * Propsの定義
 * @param previousConditionData 前回の検索条件
 */
interface Props {
  previousConditionData: SearchConditionLabelResponse;
}

export const PreviousCondition: FC<Props> = ({ previousConditionData }) => {
  return (
    <DescriptionList
      type="column2"
      column2dataBgColor="gray"
      className={styles.jobSearchTop__PreviousCondition}
      listData={[
        {
          title: '前回の検索条件',
          contents: (
            <>
              <a href={previousConditionData.transitionUrl}>
                {previousConditionData.summary === ''
                  ? '指定なし'
                  : previousConditionData.summary}
              </a>
              <ArrowRight size="S" color="blue" />
            </>
          ),
        },
      ]}
    />
  );
};
